import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES, STORAGE_KEYS } from '@/constants';
import { useAppSelector, selectUser } from '@/store';

const GUARD_SKIP_PATHS = new Set<string>([
  ROUTES.login,
  ROUTES.otp,
  ROUTES.signup,
  ROUTES.plantSelection,
  ROUTES.changePlant,
  ROUTES.workModeSelection,
  ROUTES.breakMode,
  ROUTES.shuttleTransfer,
  ROUTES.logoutSummary,
  ROUTES.maintenance,
  ROUTES.error,
  ROUTES.restrictedArea,
]);

export function ShuttleModeGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);

  const shuttleActive = localStorage.getItem(STORAGE_KEYS.shuttleModeActive) === 'true';
  const breakActive = localStorage.getItem(STORAGE_KEYS.breakModeActive) === 'true';
  const isAuthenticated = !!user;
  const onSkippedPage = GUARD_SKIP_PATHS.has(location.pathname);
  const shouldRedirect = shuttleActive && !breakActive && isAuthenticated && !onSkippedPage;

  useEffect(() => {
    if (!shouldRedirect) return;
    navigate(ROUTES.shuttleTransfer, { replace: true });
  }, [shouldRedirect, navigate]);

  return null;
}
